import { Button, LinearProgress, Tooltip, Typography } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import type { ExecutionState } from '../../api/types';
import type { TaskClasses } from './TaskListPanel';

function StartExecutionButton(props: {
  classes: TaskClasses;
  workerConnected: boolean;
  onStartExecution: () => void;
}) {
  const tooltip = props.workerConnected
    ? ''
    : 'Worker não conectado. Verifique se o Frontier Worker está rodando.';
  return (
    <Tooltip title={tooltip} arrow>
      <span>
        <Button
          variant="contained"
          className={props.classes.startButton}
          startIcon={<PlayArrowIcon />}
          onClick={props.onStartExecution}
          disabled={!props.workerConnected}
          aria-label="Iniciar Execução"
        >
          Iniciar Execução
        </Button>
      </span>
    </Tooltip>
  );
}

function ExecutionControls(props: {
  classes: TaskClasses;
  executionState: ExecutionState;
  workerConnected: boolean;
  onStartExecution: () => void;
  onPause: () => void;
  onResume: () => void;
}) {
  const { classes, executionState } = props;
  return (
    <div className={classes.controls}>
      {executionState === 'idle' && (
        <StartExecutionButton
          classes={classes}
          workerConnected={props.workerConnected}
          onStartExecution={props.onStartExecution}
        />
      )}
      {executionState === 'running' && (
        <Button
          variant="outlined"
          startIcon={<PauseIcon />}
          onClick={props.onPause}
          aria-label="Pausar"
        >
          Pausar
        </Button>
      )}
      {executionState === 'paused' && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<PlayArrowIcon />}
          onClick={props.onResume}
          aria-label="Retomar"
        >
          Retomar
        </Button>
      )}
    </div>
  );
}

export function ExecutionHeader(props: {
  classes: TaskClasses;
  completedCount: number;
  totalCount: number;
  runningCount: number;
  progressPercent: number;
  slotSummary: string | null;
  executionState: ExecutionState;
  workerConnected: boolean;
  onStartExecution: () => void;
  onPause: () => void;
  onResume: () => void;
}) {
  const progressLabel =
    props.runningCount > 1
      ? `${props.completedCount} de ${props.totalCount} tarefas concluídas, ${props.runningCount} em execução`
      : `${props.completedCount} de ${props.totalCount} tarefas concluídas`;
  return (
    <div className={props.classes.header}>
      <div className={props.classes.progressRow}>
        <Typography variant="body2">{progressLabel}</Typography>
        <Typography variant="body2" color="textSecondary">
          {Math.round(props.progressPercent)}%
        </Typography>
      </div>
      {props.slotSummary && (
        <Typography variant="body2" color="textSecondary">
          {props.slotSummary}
        </Typography>
      )}
      <LinearProgress
        variant="determinate"
        value={props.progressPercent}
        className={props.classes.progressBar}
      />
      <ExecutionControls {...props} />
    </div>
  );
}

export function EmptyTaskState(props: {
  classes: TaskClasses;
  workerConnected: boolean;
  onStartExecution: () => void;
  onPause: () => void;
  onResume: () => void;
}) {
  return (
    <div className={props.classes.root}>
      <div className={props.classes.header}>
        <ExecutionControls {...props} executionState="idle" />
      </div>
      <div className={props.classes.emptyState}>
        <Typography variant="body1">
          As tarefas serão descobertas automaticamente ao iniciar a execução.
        </Typography>
      </div>
    </div>
  );
}
